export default __webpack_public_path__ + "static/media/GroupStudy.b1155784950e624588233f9fb925608e.webp";